// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1ufJy","name":"ConsentHeader_name__yZj8_","birthday":"ConsentHeader_birthday__1-OlT","skeleton":"ConsentHeader_skeleton__SAZ2t"};